import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'

import DelayCertificateList from './DelayCertificateList'
import DelayCertificateDetail from './DelayCertificateDetail'

const DelayCertificateApp = ({ fetchDelayCertificates, delayCertificates }) => {
  useEffect(() => {
    fetchDelayCertificates()
  }, [fetchDelayCertificates])

  const { certificateId } = useParams()

  if (delayCertificates === null) return null

  if (certificateId === undefined) {
    return <DelayCertificateList delayCertificates={delayCertificates} />
  } else {
    return <DelayCertificateDetail delayCertificate={delayCertificates.find(c => c.id === parseInt(certificateId, 10))} />
  }
}

DelayCertificateApp.propTypes = {
  fetchDelayCertificates: PropTypes.func.isRequired,
  delayCertificates: PropTypes.array,
}

export default DelayCertificateApp